// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    OrgAppliedFilter,
    OrgAppliedFilterFromJSON,
    OrgAppliedFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrgSearchRequest
 */
export interface OrgSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof OrgSearchRequest
     */
    keywords?: string;
    /**
     * 
     * @type {Array<OrgAppliedFilter>}
     * @memberof OrgSearchRequest
     */
    filters?: Array<OrgAppliedFilter>;
    /**
     * 
     * @type {string}
     * @memberof OrgSearchRequest
     */
    ordering?: OrgSearchRequestOrderingEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgSearchRequest
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSearchRequest
     */
    paginationSize?: number;
}

export function OrgSearchRequestFromJSON(json: any): OrgSearchRequest {
    return {
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'filters': !exists(json, 'filters') ? undefined : (json['filters'] as Array<any>).map(OrgAppliedFilterFromJSON),
        'ordering': !exists(json, 'ordering') ? undefined : json['ordering'],
        'currentPage': !exists(json, 'current_page') ? undefined : json['current_page'],
        'paginationSize': !exists(json, 'pagination_size') ? undefined : json['pagination_size'],
    };
}

export function OrgSearchRequestToJSON(value?: OrgSearchRequest): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'keywords': value.keywords,
        'filters': value.filters === undefined ? undefined : (value.filters as Array<any>).map(OrgAppliedFilterToJSON),
        'ordering': value.ordering,
        'current_page': value.currentPage,
        'pagination_size': value.paginationSize,
    };
}

/**
* @export
* @enum {string}
*/
export enum OrgSearchRequestOrderingEnum {
    Relevance = 'relevance',
    Alphabetical = 'alphabetical',
    Popularity = 'popularity',
    Content = 'content'
}


